import React, { useState, useEffect, useRef } from 'react'
import logo from '../../Assets/aviator-logo.svg'
import burger from '../../Assets/burger.svg'
import acti from '../../Assets/activity.svg'
import dd from '../../Assets/dd.svg'
import actih from '../../Assets/history-h.svg'
import ddh from '../../Assets/dd-h.svg'

import BetControls from '../../components/BetControls'
import GraphCanvas from '../../components/GraphCanvas'
import AviatorDropdown from '../../components/AviatorDropdown'
import AviatorAutoBet from '../../components/AviatorAutoBet'
import start from '../../Assets/sounds/aviator/aviatorStart.mp3'
import amusic from '../../Assets/sounds/aviator/aviatorMusic.mp3'
import placebetSound from '../../Assets/sounds/aviator/placeBet.mp3'
import crashSound from '../../Assets/sounds/aviator/aviatorCrash.mp3'
import cashoutSound from '../../Assets/sounds/aviator/aviatorCashout.mp3'

const AviatorGame = () => {

  const startAudio = new Audio(start);
  const placeBetAudio = new Audio(placebetSound);
  const crashAudio = new Audio(crashSound);
  const cashOutAudio = new Audio(cashoutSound);
  const playCashOutSound = () => {
    cashOutAudio.play();
  };
  const playCrashSound = () => {
    crashAudio.play();
  };
  const playPlaceBetSound = () => {
    placeBetAudio.play();
  };
  const playStartSound = () => {
    startAudio.play();
  };

// let audioContext = new (window.AudioContext || window.webkitAudioContext)();
// let audioBuffer;
// let source;

// fetch(amusic) // Load the audio file
//   .then(response => response.arrayBuffer())
//   .then(data => audioContext.decodeAudioData(data))
//   .then(buffer => {
//     audioBuffer = buffer;
//   });

// function playMusic() {
//   if (audioContext.state === 'suspended') {
//     audioContext.resume(); // Resume the audio context if needed
//   }
//   source = audioContext.createBufferSource();
//   source.buffer = audioBuffer;
//   source.connect(audioContext.destination);
//   source.loop = true; // Enable continuous play
//   source.start(0);
// }

// function stopMusic() {
//   if (source) {
//     source.stop();
//   }
// }



  const [isGameRunning, setIsGameRunning] = useState(false);
  let currentMultiplier = 1.0;
  const [ displayPayout, setDisplayPayout ] = useState(1)
  let intervalId = null;
  let crashPoint = null;
  const [isPlacingBet, setIsPlacingBet] = useState({
    bet1:{
      value:false
    },
    bet2:{
      value:false
    }
  })
  const [betPlaced, setBetPlaced] = useState({
    bet1:{
      value:false
    },
    bet2:{
      value:false
    }
  })
  const [betAmount, setbetAmount] = useState({
    bet1:{
      amount:10,
      cashout:0
    },
    bet2:{
      amount:10,
      cashout:0
    }
  })
  const betPlacedRef = useRef(null)
  const placingBetRef = useRef(null)

  betPlacedRef.current = betPlaced
  placingBetRef.current = isPlacingBet
  const [multiplierSpeed, setMultiplierSpeed] = useState(60)
  const [isWaiting, setIsWaiting] = useState(false)

  function startGame() {
      // if(crashRef.current) return;
      if (isGameRunning) return;
      if(placingBetRef.current.bet1.value){
        setBetPlaced(
          (prev)=> ({
            ...prev, ['bet1']: {
              value: true
            }
          })
        )
      }
      if(placingBetRef.current.bet2.value){
        setBetPlaced(
          (prev)=> ({
            ...prev, ['bet2']: {
              value: true
            }
          })
        )
      }
      
      setIsGameRunning(true);
      playStartSound()
      currentMultiplier = 1.0;
      crashPoint = generateCrashPoint();
      intervalId = setInterval(() => {
        currentMultiplier += 0.01 * Math.pow(currentMultiplier, 0.5);
        setDisplayPayout(currentMultiplier)
        
          if (currentMultiplier >= crashPoint) {
              clearInterval(intervalId);
              crash()
            }
          }, multiplierSpeed);
        }
        if(currentMultiplier >= 3){
          setMultiplierSpeed(10)
}  
        


function generateCrashPoint() {
    return Math.random() * 10 + 1.5;
}
const [isCrash, setIsCrash] = useState(false)
const crashRef = useRef(null)

crashRef.current = isCrash
function crash(betKey) {
    clearInterval(intervalId);
    playCrashSound()
    setIsGameRunning(false);
    updateHistory(crashPoint.toFixed(2), true);
    setIsCrash(true)
    if(placingBetRef.current.bet1.value && !betPlaced.bet1.value){
      setBetPlaced(
        (prev)=> ({
          ...prev, ['bet1']: {
            value: true
          }
        })
      )
    }
    if(placingBetRef.current.bet2.value && !betPlaced.bet2.value){
      setBetPlaced(
        (prev)=> ({
          ...prev, ['bet2']: {
            value: true
          }
        })
      )
    }
    if(betPlacedRef.current.bet1.value){
      setIsPlacingBet(
        (prev)=> ({
          ...prev, ['bet1']: {
            value: false
          }
        })
      )
      setBetPlaced(
        (prev)=> ({
          ...prev, ['bet1']: {
            value: false
          }
        })
      )
    }
    if(betPlacedRef.current.bet2.value){
      setIsPlacingBet(
        (prev)=> ({
          ...prev, ['bet2']: {
            value: false
          }
        })
      )
      setBetPlaced(
        (prev)=> ({
          ...prev, ['bet2']: {
            value: false
          }
        })
      )
    }
        setTimeout(() => {
          resetGame();
          }, 5000);
}
const [ showCashOut, setShowCashOut ] = useState({
  bet1:{
    value:false
  },
  bet2:{
    value:false
  }
})





const [ balance, setBalance ] = useState(150)
const [ cashOutValue, setCashOutValue ] = useState({
  bet1:{
    value:0
  }, bet2:{
    value:0
  }
})
function cashOut(value, betKey) {
  if (!isGameRunning) return;
  playCashOutSound()
  if(!betPlaced[betKey].value) return;
  setShowCashOut(
    (prev)=> ({
      ...prev, [betKey]: {
        value: true
      }
    })
  )
  setTimeout(() => {
    setShowCashOut(
      (prev)=> ({
        ...prev, [betKey]: {
          value: false
        }
      })
    )
    }, 3000);
  setCashOutValue((prev)=> ({
    ...prev, [betKey]: {
      value: value
    }
  }))
  setIsPlacingBet(
    (prev)=> ({
      ...prev, [betKey]: {
        value: false
      }
    })
  )
  clearInterval(intervalId);
  setBetPlaced(
    (prev)=> ({
      ...prev, [betKey]: {
        value: false
      }
    })
  )
}
function resetGame() {
  currentMultiplier = 1.0;
  setDisplayPayout(1)
  setIsCrash(false)
  startGame()
}

function placeBet(betKey) {
  if (!isGameRunning) {
    setBetPlaced(
          (prev)=> ({
            ...prev, [betKey]: {
              value: true
            }
          })
        )
      setIsPlacingBet(
    (prev)=> ({
      ...prev, [betKey]: {
        value: true
      }
    })
    )
  }else{
    setIsPlacingBet(
      (prev)=> ({
        ...prev, [betKey]: {
          value: true
        }
      })
    )
  }
  playPlaceBetSound()
}
  const [multiplierHistory, setMultiplierHistory] = useState([
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    1.6,1.24,1.41,1.06,4.13, 5.21,
    
  ])
const recentHistory = multiplierHistory.slice(-7)
function updateHistory(value, isCrash) {
  
}
  const amountOpts = [
    {
      id:1,
      amt:10
    },{
      id:2,
      amt:20
    },{
      id:3,
      amt:50
    },{
      id:4,
      amt:100
    },
  ]
  const [betId, setBetId] = useState(1)

  function setNewBet(id, amt, operation, betKey){
    if(id === null && amt === null){
      if(operation === 'add') setbetAmount(
        (prev)=> ({
          ...prev, [betKey]: {
            amount: prev[betKey].amount + 1
          }
        })
      )

      if(operation === 'remove') setbetAmount(
        (prev)=> ({
          ...prev, [betKey]: {
            amount: prev[betKey].amount - 1
          }
        })
      )
    }else{
      if(betId === id){setbetAmount(
        (prev)=> ({
          ...prev, [betKey]: {
            amount: prev[betKey].amount + amt
          }
        })
      )
        
      }else{
        setBetId(id)
        setbetAmount(
          (prev)=> ({
            ...prev, [betKey]: {
              amount: amt
            }
          })
        )
      }
    }
  }
  function cancelBet(betKey){
    setBetPlaced(
      (prev)=> ({
        ...prev, [betKey]: {
          value: false
        }
      })
    )
    setIsPlacingBet(
      (prev)=> ({
        ...prev, [betKey]: {
          value: false
        }
      })
    )
  }

  const [ src, setSrc ] = useState(acti)
  const [ dsrc, setDSrc ] = useState(dd)
  const Hover =()=>{
    setSrc(actih)
    setDSrc(ddh)
  }
  const mouseLeave =()=>{
    setSrc(acti)
    setDSrc(dd)
  }
  const [ historyActive, setHistoryActive ] = useState(false)
  function setHistory(){
    setHistoryActive(!historyActive)
    setSrc(actih)
    setDSrc(ddh)
  }
  const [showDropdown, setShowDropdown] = useState(false)
  const [ auto, setAuto ] = useState({
    bet1:{
      value:false
    },
    bet2:{
      value:false
    }
  })

  function setAutoBet(betKey, value){
    setAuto(
      (prev)=> ({
        ...prev, [betKey]: {
          value: value
        }
      })
    )
  }
  const [betClass, setBetClass] = useState([
    {
      name:'All bets',
      slug:'allbets'
    },{
      name:'My Bets',
      slug:'mybets'
    },{
      name:'Top',
      slug:'top'
    },
  ])
  const [activeBetClass, setActiveBetClass] = useState({
    name:'All bets',
    slug:'allbets'
  })
  const [winType, setWinType] = useState([
    {
      name:'HUGE WINS',
      slug:'hugewins'
    },{
      name:'BIGGEST WINS',
      slug:'biggestwins'
    },{
      name:'MULTIPLIERS',
      slug:'multipliers'
    },
  ])
  const [activeWinType, setActiveWinType] = useState(
    {
      name:'HUGE WINS',
      slug:'hugewins'
    }
  )
  const [winEra, setWinEra] = useState([
    {
      name:'Day',
      slug:'day'
    },{
      name:'Month',
      slug:'month'
    },{
      name:'Year',
      slug:'year'
    },
  ])
  const [activeWinEra, setActiveWinEra] = useState(
    {
      name:'Day',
      slug:'day'
    }
  )
  
  const [autoCashoutValue, setAutoCashoutValue] = useState({
    bet1:{
      value:2
    },
    bet2:{
      value:2
    },
  })
  const [cashoutAuto, setCashoutAuto] = useState({
    bet1:{
      value:false
    },
    bet2:{
      value:false
    },
  })
  function autoCashout(betKey, value){
    setCashoutAuto(
      (prev)=> ({
        ...prev, [betKey]: {
          value: true
        }
      })
    )
    setAutoCashoutValue(
      (prev)=> ({
        ...prev, [betKey]: {
          value: value
        }
      })
    )
  }
  const hasExecuted = useRef(false)
  const hasExecutedB = useRef(false)
  useEffect(()=>{
    if(cashoutAuto.bet1.value && displayPayout >= autoCashoutValue.bet1.value && !hasExecuted.current ){
      console.log('auto cashout true', displayPayout)
      cashOut(autoCashoutValue.bet1.value, 'bet1')
      hasExecuted.current = true
    }
    if(displayPayout === 1) hasExecuted.current = false
    if(cashoutAuto.bet2.value && displayPayout >= autoCashoutValue.bet2.value && !hasExecutedB.current ){
      console.log('auto cashout true', displayPayout)
      cashOut(autoCashoutValue.bet2.value, 'bet2')
      hasExecutedB.current = true
    }
    if(displayPayout === 1) hasExecutedB.current = false
  }, [displayPayout])
  const [showAutoOptions, setShowAutoOptions] = useState(false)

  return (
    <div className='bg-[#0e0e0e] w-[100vw] sm:w-[500px] select-none'>
      <div className='bg-[#1b1c1d] p-2 flex justify-between items-center w-full'>
        <img className='w-[85px]' src={logo} alt='Aviator'/>
        <div className='flex space-x-2'>
          <p className='border border-gray-600 rounded-full px-3 text-[#28a909] font-semibold'>{balance.toFixed(2)} $</p>
          <div onClick={() => setShowDropdown(!showDropdown)} className='cursor-pointer flex justify-center items-center border-l border-gray-500 px-2 p-1'>
            <img  src={burger} alt='menu'/>
          </div>
        </div>
        {
          showDropdown &&
          <AviatorDropdown/>
        }
        {
          showAutoOptions &&
          <AviatorAutoBet show={setShowAutoOptions}/>
        }
      </div>

      <div className='flex flex-col  p-2'>
        <div className='relative flex justify-between items-center'>
          {
            recentHistory.map((history, index) =>(
              <p key={index} className={`font-bold bg-[#131418] ${history > 3.9 ? 'text-[#6930b0]' :'text-blue-400'} rounded-full px-2 font-semibold w-auto text-sm`}>{history}x</p>
            ))}

          {!historyActive ? 
          <div onMouseEnter={Hover} onMouseLeave={mouseLeave} onClick={setHistory} className='cursor-pointer space-x-1 absolute bg-[#252528] flex justify-center px-2 p-1 items-center rounded-full border border-[#3d3d43] -right-1 shadow-2xl'>
            <img  src={src} alt='menu'/>
            <img src={dsrc} alt='menu' className={`transition-transform duration-500 ease-in-out ${historyActive && 'rotate-180'}`}/>
          </div>
        :
        <div className='flex flex-col absolute w-full z-40 top-0 -right-1'>
          <div className='flex justify-between rounded-t-lg bg-[#1f2128] p-1'>
            <p className='text-white'>ROUND HISTORY</p>
          <div  onClick={setHistory} className='cursor-pointer space-x-1  bg-[#252528] flex justify-center px-2 p-1 items-center rounded-full border border-[#3d3d43] -right-1 shadow-2xl'>
              <img  src={actih} alt='menu'/>
              <img src={ddh} alt='menu' className={`transition-transform duration-500 ease-in-out ${historyActive && 'rotate-180'}`}/>
          </div>
          </div>
          <div className='bg-[#252830] rounded-b-lg flex flex-wrap gap-2  p-2'>
          {
            multiplierHistory.map((history, index) =>(
              <p key={index} className={`font-bold bg-[#131418] ${history > 3.9 ? 'text-[#6930b0]' :'text-blue-400'} rounded-full px-2 font-semibold w-auto text-sm`}>{history}x</p>
            ))}
          </div>
        </div>
        }
        </div>
        <div className=' border-2 multiplier border-[#19191a] p-3 flex  my-2 '>
          <div className='flex flex-col space-y-5 z-10 '>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
            <div className='bg-blue-500 rounded-full w-[5px] h-[5px]'/>
          </div>
          <div className='w-full z-10 flex flex-col justify-center items-center'>

          <div onClick={startGame} className='ml-2 mb-2 border-l-2 border-b-2 border-[#19191a]  w-full h-full flex flex-col justify-center items-center'>
          {isCrash && <p className='text-2xl text-white font-semibold'>Flew Away!</p>}
          <p className={`text-6xl p-2 ${isCrash ? 'text-red-600' : 'text-white'} font-bold `}>{displayPayout.toFixed(2)}x</p>
          { isGameRunning &&
            <GraphCanvas displayPayout={displayPayout}/>
          }
          </div>
          <div className="relative w-full overflow-hidden">
            <marque behavior="scroll" direction="left" scrollamount="4" className="flex justify-between ">
              {Array.from({ length: 10 }).map((_, index) => (
                <div key={index} className="bg-white rounded-full w-[5px] h-[5px]" />
              ))}
            </marque>
          </div>
          </div>
          
        </div>
        <div className='flex flex-col space-y-2'>
          <BetControls
          betKey={'bet1'}
        betAmount={betAmount.bet1.amount} 
        show={setShowAutoOptions}
        autoCashout={autoCashout} 
        autoCashoutValue={autoCashoutValue.bet1.value}
        placeBet={placeBet}
        cashOut={cashOut}
        setNewBet={setNewBet}
        cancelBet={cancelBet}
        betPlaced={betPlaced.bet1.value}
        amountOpts={amountOpts}
        isGameRunning={isGameRunning}
        displayPayout={displayPayout}
        isPlacingBet={isPlacingBet.bet1.value}
        auto={auto.bet1.value}
        setAutoBet={setAutoBet}
        />
        <BetControls
        betKey={'bet2'}
        show={setShowAutoOptions}
        betAmount={betAmount.bet2.amount} 
        autoCashout={autoCashout} 
        autoCashoutValue={autoCashoutValue.bet2.value}
        placeBet={placeBet}
        cashOut={cashOut}
        setNewBet={setNewBet}
        cancelBet={cancelBet}
        betPlaced={betPlaced.bet2.value}
        amountOpts={amountOpts}
        isGameRunning={isGameRunning}
        displayPayout={displayPayout}
        isPlacingBet={isPlacingBet.bet2.value}
        auto={auto.bet2.value}
        setAutoBet={setAutoBet}
        />
        </div>
        
        <div className='bg-[#1b1c1d] p-2 mt-4 flex flex-col justify-center items-center rounded-lg'>
            
            <div className='relative flex bg-[#141516] rounded-full'>
            <div className={`absolute transition-transform duration-500 ${activeBetClass.slug === 'allbets' ? 'translate-x-0' : ''} ${activeBetClass.slug === 'mybets' ? 'translate-x-full' : ''} ${activeBetClass.slug === 'top' ? 'translate-x-[180px]' : ''} bg-[#2c2d30] w-[90px] h-[20px] text-center rounded-full`}/>
              {betClass.map((item, index) => (
                <p key={index} onClick={() => setActiveBetClass(item)} className={`text-sm w-[90px] text-center rounded-full cursor-pointer z-20 ${item.slug === activeBetClass.slug ? 'text-white' : 'text-gray-400 hover:text-red-700'}`}>{item.name}</p>
              ))}
              
            </div>

            {activeBetClass.slug === 'top' && <div className='flex flex-col justify-center items-center'>

            <div className='relative my-2 flex rounded-full'>
              {winType.map((item, index) => (
                <p key={index} onClick={() => setActiveWinType(item)} className={`text-[0.8rem] px-1 text-center rounded-lg cursor-pointer z-20 ${item.slug === activeWinType.slug ? 'border border-red-600' : ''} text-white`}>{item.name}</p>
              ))}
              
            </div>    

            <div className='relative flex bg-[#141516] rounded-full'>
            <div className={`absolute transition-transform duration-500 ${activeWinEra.slug === 'day' ? 'translate-x-0' : ''} ${activeWinEra.slug === 'month' ? 'translate-x-full' : ''} ${activeWinEra.slug === 'year' ? 'translate-x-[180px]' : ''} bg-[#2c2d30] w-[90px] h-[20px] text-center rounded-full`}/>
              {winEra.map((item, index) => (
                <p key={index} onClick={() => setActiveWinEra(item)} className={`text-sm w-[90px] text-center rounded-full cursor-pointer z-20 ${item.slug === activeWinEra.slug ? 'text-white' : 'text-gray-400 hover:text-red-700'}`}>{item.name}</p>
              ))}
              
            </div>
            </div>}

          {activeBetClass.slug === 'allbets' && 
          <div className='flex flex-col w-full'>
            <div className='flex justify-between items-center p-2 w-full'>
              <div className='flex flex-col'>
                <p className='text-white'>ALL BETS</p>
                <p className='text-white'>230</p>
              </div>
              <div className='flex justify-center items-center space-x-1 rounded-full border border-gray-400 py-[0.1rem] px-1'>
              <img className='w-[15px] h-[15px]' src={acti} alt='menu'/>
              <p className='text-sm text-gray-400'>Previous Round</p>
              </div>
            </div>
          
          <div className='flex justify-between border-t border-t-black text-gray-400 text-sm w-full'>
              <p>User</p>
              <p>Bet USD</p>
              <p className='text-center'>x</p>
              <p>Cash out USD</p>
          </div>
          <div className='mt-2 flex flex-col w-full'>
          <div className='flex mt-1 justify-between text-gray-400 text-sm w-full px-1 py-2 rounded-lg border border-[#01b41f] bg-[#07360b]'>
              <p>m****6</p>
              <p>100.00</p>
              <p className={`bg-black text-blue-400 rounded-full px-2 font-semibold w-auto text-sm`}>1.38x</p>
              <p>138.00</p>
          </div>
          
          </div>
        </div>}

        {activeBetClass.slug === 'mybets' && 
          <div className='flex flex-col w-full mt-2'>
          <div className='flex justify-between text-gray-400 text-sm w-full'>
              <p>Date</p>
              <p>Bet USD</p>
              <p className='text-center'>x</p>
              <p>Cash out USD</p>
          </div>
          <div className='mt-2 flex flex-col w-full'>
          <div className='flex mt-1 justify-between text-gray-400 text-sm w-full px-1 py-2 rounded-lg border border-[#01b41f] bg-[#07360b]'>
              <div className='flex flex-col space-y-0 text-white text-[0.6rem]'>
                <p className='h-[10px] w-auto'>19:44 </p>
                <p className='h-[10px] w-auto'>17-03-25</p>
              </div>
              <p>100.00</p>
              <p className={`bg-black text-blue-400 rounded-full px-2 font-semibold w-auto text-sm`}>1.38x</p>
              <p>138.00</p>
          </div>
          
          </div>
        </div>}

        </div>    


      </div>
      {showCashOut.bet1.value && <div className='absolute self-center  top-10 flex justify-between border w-full max-w-[500px] z-50 border-[#01b41f] bg-[#07360b] items-center rounded-full p-1'>
        <div className='flex flex-col justify-center items-center w-full px-4'>
          <p className='text-[0.8rem] text-gray-500'>You have cashed out!</p>
          <p className='text-2xl text-white'>{cashOutValue.bet1.value.toFixed(2)}x</p>
        </div>

        <div className='flex justify-center items-center flex-col rounded-full px-4 w-full bg-[#01b41f]'>
          <p className='text-white font-semibold'>Win</p>
          <p className='text-white font-semibold'>${(cashOutValue.bet1.value * betAmount.bet1.amount).toFixed(2)}</p>
        </div>

        <p onClick={() => setShowCashOut(
    (prev)=> ({
      ...prev, ['bet1']: {
        value: false
      }
    })
  )} className='p-2 text-gray-400 text-2xl cursor-pointer'>x</p>
      </div>}
      {showCashOut.bet2.value && <div className='absolute self-center  top-[7rem] flex justify-between border w-full max-w-[500px] z-50 border-[#01b41f] bg-[#07360b] items-center rounded-full p-1'>
        <div className='flex flex-col justify-center items-center w-full px-4'>
          <p className='text-[0.8rem] text-gray-500'>You have cashed out!</p>
          <p className='text-2xl text-white'>{cashOutValue.bet2.value.toFixed(2)}x</p>
        </div>

        <div className='flex justify-center items-center flex-col rounded-full px-4 w-full bg-[#01b41f]'>
          <p className='text-white font-semibold'>Win</p>
          <p className='text-white font-semibold'>${(cashOutValue.bet2.value * betAmount.bet2.amount).toFixed(2)}</p>
        </div>

        <p onClick={() => setShowCashOut(
    (prev)=> ({
      ...prev, ['bet2']: {
        value: false
      }
    })
  )} className='p-2 text-gray-400 text-2xl cursor-pointer'>x</p>
      </div>}
      
    </div>
  )
}

export default AviatorGame